import React from "react"
import PropTypes from "prop-types"

import {startsWith} from "lodash"
import Link, {RouterLink} from "@irati/ui/src/Link"
import id from "@irati/utils/id"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import isContentKey from "@irati/utils/lang/helpers/isContentKey"

import StyledSectionHeader from "./styled/SectionHeader"
import Header from "./Header"

const SectionHeader = (props, context) => {
  const {linkLabel, linkTo, onClick, capitalise, className, children, headerText, logo, seeMoreUrl, formatMessage} = props

  const isExternalUrl = startsWith(seeMoreUrl, "http")
  const idNamespace = id("section-header", props)
  const hasLink = linkLabel && linkTo
  const normalisedHeaderText = isContentKey(headerText) ? formatMessage({id: headerText}) : headerText

  return (
    <StyledSectionHeader id={idNamespace} capitalise={capitalise} className={className}>
      <Flex justifyContent="space-between" alignItems="center">
        <Header logo={logo} id={idNamespace}>
          {children || normalisedHeaderText}
        </Header>
        {hasLink && (
          <RouterLink
            cta
            id={id("link", idNamespace)}
            to={linkTo}
            onClick={onClick}>
            <Flex alignItems="center">
              <FormattedMessage id={linkLabel} />
              <Icon icon={IconTypes.arrowRight} marginLeft />
            </Flex>
          </RouterLink>
        )}
        {seeMoreUrl && !isExternalUrl && (
          <RouterLink
            cta
            id={id("link", idNamespace)}
            app={context.apps.PLATFORM}
            to={seeMoreUrl}>
            <Flex alignItems="center">
              <FormattedMessage id="perks.containers.homepage.customisation.moreLink" />
              <Icon icon={IconTypes.arrowRight} marginLeft />
            </Flex>
          </RouterLink>
        )}
        {seeMoreUrl && isExternalUrl && (
          <Link cta target="_blank" href={seeMoreUrl}>
            <Flex alignItems="center">
              <FormattedMessage id="perks.containers.homepage.customisation.moreLink" />
              <Icon icon={IconTypes.arrowRight} marginLeft />
            </Flex>
          </Link>
        )}
      </Flex>
    </StyledSectionHeader>
  )
}

SectionHeader.propTypes = {
  children: PropTypes.node,
  headerText: PropTypes.string,
  linkLabel: PropTypes.string,
  linkTo: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  logo: PropTypes.string,
  capitalise: PropTypes.bool,
  seeMoreUrl: PropTypes.string,
  formatMessage: PropTypes.func
}
SectionHeader.defaultProps = {
  linkLabel: null,
  linkTo: null,
  onClick: () => {},
  className: null,
  logo: null,
  capitalise: false
}
SectionHeader.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default injectIntl(SectionHeader)
